import { useTitle } from "@/lib/site";
import { Hero } from "@/components/home/Hero";
import { HeroSearch } from "@/components/home/HeroSearch";
import { MakesMarquee } from "@/components/home/MakesMarquee";
import { LatestArrivals } from "@/components/home/LatestArrivals";
import { Welcome } from "@/components/home/Welcome";
import { Reputation } from "@/components/home/Reputation";
import { VisitUs } from "@/components/home/VisitUs";

export default function Home() {
  useTitle("Used Cars for Sale in Peterborough | YK Motors");
  return (
    <>
      <Hero />
      <HeroSearch />
      <MakesMarquee />
      <LatestArrivals />
      <Welcome />
      <Reputation />
      <VisitUs />
    </>
  );
}
